import { useField } from 'formik'
import React from 'react'

import Select, { Option } from '@/components/Select'

import { formikSelect } from './styles.css'

type Props = {
  dataTestId?: string
  error?: string
  handleTracking?: () => void
  label?: string
  name: string
  onClick?: () => void
  options: Option[]
  placeholder?: string
  required?: boolean
  warning?: string | React.ReactNode
}

const FormikSelect: React.FC<Props> = ({
  dataTestId = 'select',
  error,
  handleTracking,
  label,
  name,
  onClick,
  options,
  placeholder,
  required,
  warning,
}) => {
  const [field, meta, form] = useField({
    name,
    onClick,
    placeholder,
    required,
  })

  const { value } = field
  const { error: errorFromFormik } = meta

  return (
    <Select
      className={formikSelect}
      dataTestId={dataTestId}
      error={errorFromFormik && error}
      label={label}
      name={name}
      options={options}
      placeholder={placeholder}
      required={required}
      value={value}
      warning={errorFromFormik && warning}
      onClick={onClick}
      onSelect={(opt) => {
        form.setValue(opt.value)
        typeof handleTracking === 'function' && handleTracking()
      }}
    />
  )
}

export default FormikSelect
